import { FieldPath, FieldValues, useWatch } from "react-hook-form";
import { useEffect } from "react";
import { RhfAutoComplete } from "./RhfAutoComplete";
import { useFetchPlantGsdbForPlantTypes } from "./Hooks/useFetchPlantGsdbForPlantTypes";
import { ttProtectionFilterUrls } from "../../../../URL/ApplicationUrls";
import { isArrayUndefinedOrEmpty } from "../../../../Utils/arrays";
import { RhfInputProps } from "../../../../Forms/RhfInputProps";

type Props<
  TFieldValues extends FieldValues = FieldValues,
  TNameToWatch extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  nameToSubscribeTo: TNameToWatch;
};

export const TTProtectionFiltersPlantGsdbMultiSelect = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
>({
  control,
  name,
  nameToSubscribeTo,
}: RhfInputProps<TFieldValues, TName> & Props<TFieldValues, TName>) => {
  const plantTypes = useWatch({ control, name: nameToSubscribeTo });

  const { data: plantsForPlantTypes, refetch } = useFetchPlantGsdbForPlantTypes({
    url: ttProtectionFilterUrls.plantsByPlantTypes,
    plantTypes,
  });

  useEffect(() => {
    refetch();
  }, [plantTypes, refetch]);

  return (
    <RhfAutoComplete
      control={control}
      name={name}
      options={isArrayUndefinedOrEmpty(plantsForPlantTypes) ? [] : plantsForPlantTypes}
      label="Plant GSDB"
    />
  );
};
